import {Client} from "../../autogenerate/api.generated.clients";

export const useCreateCompressorOrgAssociation = function () {
    return {
        createCompressorOrganizationAssociation: (frameSerialNumber: string, organizationId: number) => new Client().organization_CreateCompressorOrgAssociation(frameSerialNumber, organizationId)
    }
}

